import {
    type MembershipProfileAnswerWithQuestion,
    type MembershipProfileCategory,
    type ProfileAnswer,
    type QuestionKey,
} from '@fruitful/member-profile';

import { requestBuilder } from '../../http/RequestBuilder';
import { findMembershipProfileAnswerByQuestionKey } from '../utils/memberProfileUtils';

interface MembershipProfileAnswerQuery {
    category?: MembershipProfileCategory;
    questionKey: QuestionKey;
}

const useGetMembershipProfileAnswersQuery = requestBuilder.query<
    // There is not a clean way to add another layer of generic typing to requestBuilder, use the static union type here
    Array<MembershipProfileAnswerWithQuestion<ProfileAnswer>>,
    { category?: MembershipProfileCategory }
>({
    endpoint: ({ category }) =>
        `/api/membership-profile/answer${category != null ? `?category=${category}` : ''}`,
    queryKey: ({ category }) => `getMembershipProfileAnswers/${category}`,
});

const useGetMembershipProfileAnswer = <T extends ProfileAnswer>({
    category,
    questionKey,
}: MembershipProfileAnswerQuery) => {
    const { data, ...rest } = useGetMembershipProfileAnswersQuery({ category });

    const question = findMembershipProfileAnswerByQuestionKey<T>(
        // Cast union typing to more specific T
        (data as Array<MembershipProfileAnswerWithQuestion<T>>) ?? [],
        questionKey,
    );

    return {
        ...rest,
        data: question,
    };
};

export default useGetMembershipProfileAnswer;
